import React from 'react';

export function WhiteCard({className, children}) {
    return <div className={`bg-light-subtle p-2 border rounded shadow-sm mb-2 ${className}`}>{children}</div>
}